import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef } from "react";
import { Flex, Paper, Header3, TextInput, PrimaryButton, SecondaryButton } from "@base-ui";
import { closePopup, blockDefaultEvent } from "utils/events";
import { useLockedFocusArea } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TextInputPopup(_ref) {
  var id = _ref.id,
    title = _ref.title,
    label = _ref.label,
    submitLabel = _ref.submitLabel,
    callback = _ref.callback,
    placeholder = _ref.placeholder,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  var handleCancel = function handleCancel(e) {
    blockDefaultEvent(e);
    closePopup();
  };
  var handleConfirm = function handleConfirm() {
    callback(value);
    closePopup();
  };
  return /*#__PURE__*/_jsxs(Paper.Column, {
    width: "500px",
    ref: containerRef,
    children: [/*#__PURE__*/_jsx(Header3, {
      id: "dialog-title",
      inverted: true,
      p: "15px 20px",
      backgroundColor: "P3",
      m: "0",
      children: title
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      p: "sm",
      children: [/*#__PURE__*/_jsx(TextInput, {
        id: id,
        onChange: setValue,
        label: label,
        autoFocus: true,
        textRef: firstRef,
        border: "primary",
        value: value,
        placeholder: placeholder,
        onKeyPress: function onKeyPress(e) {
          return e.key === "Enter" && handleConfirm();
        },
        background: "G3"
      }), /*#__PURE__*/_jsxs(Flex.Row, {
        justifyContent: "flex-end",
        mt: "40px",
        children: [/*#__PURE__*/_jsx(SecondaryButton, {
          id: "leave-popup",
          mr: "10px",
          width: "140px",
          onClick: handleCancel,
          children: "Avbryt"
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          ref: lastRef,
          id: "confirm",
          width: "fit-content",
          p: "0 40px",
          disabled: !value.length,
          onClick: function onClick() {
            return handleConfirm();
          },
          children: submitLabel
        })]
      })]
    })]
  });
}